import axios from "axios";

export function sendCollegeIDReminderText(scholarshipId) {
    return axios.post("/api/services/app/Message/SendCollegeIDReminderText", null, { params: { scholarshipId } });
}

export function sendFerpaReminderText(scholarshipId) {
    return axios.post("/api/services/app/Message/SendFerpaReminderText", null, { params: { scholarshipId } });
}
